"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDynamicLink = void 0;
__exportStar(require("./types"), exports);
/**
 * 构建一个DynamicLink长链接
 * https://firebase.google.com/docs/dynamic-links/create-manually
 * @param options
 */
function buildDynamicLink(options = {}) {
    const { url = "https://www.pionex.com/", page, params, referral, afl = "https://download.pionex.com", ifl = "https://download.pionex.com", debug, } = options;
    /**
     * 子域名
     */
    let subdomain = "pionex";
    /**
     * Android package name
     */
    let apn = "com.pionex.client";
    /**
     * iOS bundle id
     */
    let ibi = "org.pionex";
    const linkSearchParams = new URLSearchParams();
    if (page) {
        linkSearchParams.set("page", page);
    }
    if (params) {
        linkSearchParams.set("params", JSON.stringify(params));
    }
    if (referral) {
        linkSearchParams.set("referral", referral);
    }
    const link = `${url}${url.includes("?") ? "&" : "?"}${linkSearchParams.toString()}`;
    const searchParams = new URLSearchParams();
    searchParams.set("link", link);
    searchParams.set("apn", apn);
    searchParams.set("ibi", ibi);
    searchParams.set("afl", afl);
    searchParams.set("ifl", ifl);
    if (debug) {
        searchParams.set("d", "1");
    }
    return `https://${subdomain}.page.link/?${searchParams.toString()}`;
}
exports.buildDynamicLink = buildDynamicLink;
